import React from 'react';
import PropTypes from 'prop-types';

export default function IconFloatMessenger({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4972 0.883958L10.9812 6.48817C10.4172 7.3642 9.21722 7.59221 8.37722 6.93218L5.56923 4.85611C5.4446 4.76263 5.29301 4.7121 5.13722 4.7121C4.98144 4.7121 4.82985 4.76263 4.70522 4.85611L0.913224 7.73621C0.409224 8.13223 -0.250776 7.53221 0.097224 6.98019L3.61322 1.37598C4.17722 0.499944 5.37722 0.271935 6.21723 0.895959L9.02522 3.00804C9.14985 3.10151 9.30144 3.15204 9.45722 3.15204C9.61301 3.15204 9.7646 3.10151 9.88922 3.00804L13.6812 0.12793C14.1852 -0.268085 14.8452 0.331937 14.4972 0.883958Z"
        fill={color}
      />
    </svg>
  );
}

IconFloatMessenger.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
